import { useAppSelector } from '../../store/hooks';
import MediaControls from '../../components/mediacontrols/MediaControls';
import MicButton from '../../components/controlbuttons/MicButton';
import WebcamButton from '../../components/controlbuttons/WebcamButton';
import ScreenshareButton from '../../components/controlbuttons/ScreenshareButton';

const ControlButtonsBar = (): JSX.Element => {
	const controlButtonsBar =
		useAppSelector((state) => state.settings.controlButtonsBar);
	const hideSelfView = useAppSelector((state) => state.settings.hideSelfView);
	const isMobile = useAppSelector((state) => state.me.browser.platform === 'mobile');

	return (
		<>
			{ (hideSelfView || controlButtonsBar || isMobile) &&
				<MediaControls
					orientation={ isMobile ? 'horizontal' : 'vertical' }
					horizontalPlacement={ isMobile ? 'center' : 'left' }
					verticalPlacement={ isMobile ? 'bottom' :'center' }
					autoHide={false}
				>
					<MicButton
						onColor='default'
						offColor='error'
						disabledColor='default'
					/>
					<WebcamButton
						onColor='default'
						offColor='error'
						disabledColor='default'
					/>
					{ !isMobile && <ScreenshareButton /> }
				</MediaControls>
			}
		</>
	);
};

export default ControlButtonsBar;